var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"conten"},[_c('img',{attrs:{"src":require("../../../../../../public/img/finish.jpeg"),"alt":""}}),_c('div',{staticClass:"but"},[_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.success}},[_vm._v("完成")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }